import { request } from "../utils/request"


export const getLogs = (params: { page: number, limit: number }) => {
    return request.get('/log', { params })
}
